<template>
    <div class="d-flex justify-center align-center flex-column">
        <vue-headful :title="$t('title_ranking')" description="title" />
        <v-container fluid fill-height>
            <v-row class="mt-7 mb-4 mx-12">
                <TopBar />
            </v-row>
        </v-container>
        <div class="w-90 d-flex justify-center align-center">
            <OptionPanel />
        </div>
        <v-container fluid fill-height class="pa-0">
            <v-row class="pa-0">
                <v-col cols="12" class="pa-0">
                    <v-card min-height="500" elevation="0">
                        <MainContent :ranking_data="rankingData" v-if="rankingData" />
                        <v-overlay absolute :value="!rankingData" opacity="0">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                                size="150"
                                :width="15"
                            />
                        </v-overlay>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue';

import RankingService from '@/services/ranking'

import TopBar from '@/components/home/TopBar.vue'
import MainContent from '@/components/ranking/MainContent.vue'
import OptionPanel from '@/components/ranking/OptionPanel.vue'

export default {
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            school: (state) => state.userData.user.school,
        }),
    },
    components: {
        TopBar,
        MainContent,
        OptionPanel,
    },
    data() {
        return {
            rankingData: null,
        }
    },
    methods: {
        ...mapActions(['setRankingMode']),
    },
    async mounted() {
        const response = await RankingService.getRankings(this.school.id).catch((error) => {
            Sentry.captureException(error)
            this.$modal.loadError()
        })
        if (!response) {
            this.$modal.loadError()
            return
        }
        this.rankingData = response.content
        this.setRankingMode('school')
        window.ChurnZero.push(['trackEvent', 'ranking', 'Go to Ranking']);
    },
}
</script>
